import React, {useState} from 'react'
import Form from "react-bootstrap/Form";
import PulsingSearchButton from "../PulsingSearchButton/PulsingSearchButton";

export default function ManualSearchBar({currentSearchFilter, updateCurrentFilter, placeholder = "Enter a pattern name."}) {
    const [localFilter, setLocalFilter] = useState(currentSearchFilter || "")

    const canSubmit = localFilter !== currentSearchFilter && !(localFilter === "" && currentSearchFilter === null);

    return <div style={{display: "flex", paddingBlock: 0, marginBottom: -6,}}>
        <Form.Control
            style={{width: "100%"}}
            type="text"
            placeholder={placeholder}
            value={localFilter ?? ""}
            onChange={(event) => {
                setLocalFilter(event.target.value)
            }}
            onKeyDown={(event) => {
                if (event.key === "Enter" && canSubmit) {
                    updateCurrentFilter(localFilter)
                }
            }}
        />
        <PulsingSearchButton clickFunc={() => updateCurrentFilter(localFilter)} active={canSubmit}/>
    </div>
}